import { MagnifyingGlass } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";

export default function SearchBar({ value, onChange, placeholder = "Cari...", testid = "search-input", count }) {
  return (
    <div className="mb-4 flex items-center gap-3 max-w-md">
      <div className="relative flex-1">
        <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="pl-10 rounded-none"
          data-testid={testid}
        />
      </div>
      {count !== undefined && (
        <div className="text-xs text-gray-500 font-mono-num whitespace-nowrap">{count} data</div>
      )}
    </div>
  );
}
